import { createRouter, createWebHistory } from 'vue-router'
import HomeView                           from '@/views/Home'
import AdminView                          from '@/views/admin/Admin'
import Login                              from '@/views/Login'
import AuthCallback                       from '@/views/AuthCallback'
import TenantSelector                     from '@/views/TenantSelector'
import InviteAccept                       from '@/views/InviteAccept'
import DashboardView                      from '@/views/dashboard/Dashboard'
import InvestmentsView                    from '@/views/investments/InvestmentsView'
import FundInvestment                     from '@/views/investments/FundInvestment'
import CompanyInvestment                  from '@/views/investments/CompanyInvestment'
import ReportsView                        from '@/views/reports/Reports'
import ReportView                         from '@/views/reports/Report'
import DataCollectionView                 from '@/views/dataCollection/DataCollection'
import MappingView                        from '@/views/mapping/Mapping'

const routes = [
	{
		path: '/login',
		name: 'Login',
		component: Login,
		meta: { public: true }
	},
	{
		path: '/auth/callback',
		name: 'AuthCallback',
		component: AuthCallback,
		meta: { public: true }
	},
	{
		path: '/invite',
		name: 'InviteAccept',
		component: InviteAccept,
		meta: { public: true }
	},
	{
		path: '/select-tenant',
		name: 'SelectTenant',
		component: TenantSelector,
		meta: { requiresAuth: true }
	},
	{
		path: '/',
		name: 'HomeView',
		meta: {
			requiresAuth: true,
		},
		component: HomeView,
		children: [
			{
				name: 'DashboardView',
				path: '/',
				component: DashboardView,
				meta: {
					title: 'Dashboard'
				}
			},
			{
				name: 'InvestmentsView',
				path: 'investments',
				component: InvestmentsView,
				meta: {
					title: 'Investments'
				}
			},
			{
				name: 'FundInvestment',
				component: FundInvestment,
				path: 'funds/:fundId',
				meta: {
					title: 'Investments'
				}
			},
			{
				name: 'CompanyInvestment',
				component: CompanyInvestment,
				path: 'investments/:investmentId',
				meta: {
					title: 'Investments'
				}
			},
			{
				name: 'ReportsView',
				path: 'reports',
				component: ReportsView,
				meta: {
					title: 'Reports'
				}
			},
			{
				name: 'ReportView',
				path: 'report',
				component: ReportView,
				// Selection lives in the query string, not the path. It used to be
				// eight optional positional segments padded with '-' sentinels,
				// which only existed because a positional segment cannot be
				// skipped. Mapping query -> props keeps ReportView's interface
				// unchanged: an omitted param simply arrives undefined, which every
				// consumer already treats as "all".
				props: route => ({ ...route.query }),
				meta: {
					title: 'Custom Report'
				}
			},
			{
				name: 'DataCollectionView',
				path: 'dataCollection',
				component: DataCollectionView,
				meta: {
					title: 'Data Collection'
				}
			},
			{
				name: 'MappingView',
				path: 'mapping',
				component: MappingView,
				meta: {
					title: 'Mapping'
				}
			},
			{
				name: 'AdminView',
				path: 'admin',
				component: AdminView,
				meta: {
					title: 'Admin'
				}
			},
			{
				path: 'admin/company',
				name: 'CompanyList',
				meta: {
					title: 'Admin - Companies',
					requiresPermission: 'admin:settings:manage'
				},
				component: () => import(/* webpackChunkName: "companyList" */ '../views/company/List.vue')
			},
			{
				path: 'admin/company/:id',
				name: 'CompanyShow',
				meta: {
					title: 'Admin - Companies',
					requiresPermission: 'admin:settings:manage'
				},
				component: () => import(/* webpackChunkName: "companyShow" */ '../views/company/Show.vue')
			},
			{
				path: '/admin/company/create',
				name: 'CompanyCreate',
				meta: {
					title: 'Admin - Companies',
					requiresPermission: 'admin:settings:manage'
				},
				component: () => import(/* webpackChunkName: "companyCreate" */ '../views/company/Create.vue')
			},
			{
				path: '/admin/company/:id/edit',
				name: 'CompanyEdit',
				meta: {
					title: 'Admin - Companies',
					requiresPermission: 'admin:settings:manage'
				},
				component: () => import(/* webpackChunkName: "companyEdit" */ '../views/company/Edit.vue')
			},
			{
				path: 'admin/user',
				name: 'UserList',
				meta: {
					title: 'Admin - Users',
					requiresPermission: 'admin:users:manage'
				},
				component: () => import(/* webpackChunkName: "useList" */ '../views/user/List.vue')
			},
			{
				path: 'admin/user/create',
				name: 'UserCreate',
				meta: {
					title: 'Admin - Users',
					requiresPermission: 'admin:users:manage'
				},
				component: () => import(/* webpackChunkName: "useCreate" */ '../views/user/Create.vue')
			}
		]
	},
	{
		// Last resort. Without this an unmatched path renders nothing at all —
		// no error, no redirect, just a blank page. That matters more now that
		// report URLs moved to query params with no redirect shim, so any old
		// positional report link (/report/abc/def/...) arrives here.
		name: 'NotFound',
		path: '/:pathMatch(.*)*',
		component: () => import(/* webpackChunkName: "notFound" */ '@/views/NotFound.vue'),
		meta: {
			title: 'Not Found'
		}
	}
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

export default router
